module.exports = __webpack_public_path__ + "img/unchecked-checkbox.e230c79a.svg";